import { login, smslogin, getPhone, updatePass, smsupdatePass, versmscode, sweepCodeLogin, registerAccount, switchCompany } from '@/api/user'
import { noticeList } from '@/api/common'
import { get, set, remove } from '@/utils/storage'
import { resetRouter } from '@/router'
const tokenKey = process.env.VUE_APP_STORAGE_TOKEN // token
const userinfoKey = process.env.VUE_APP_STORAGE_USERINFO // userinfo

const getDefaultState = () => {
  return {
    token: get(tokenKey) || '',
    userinfo: JSON.parse(get(userinfoKey)) || {},
    userPhone: '',
    noRead: 0, // 未读消息个数
    updateVersion: false,
    versionContent: '',
    version: get('version') || '',
    nodeAuth: get('nodeAuth') || [],
    systemNode: false
  }
}

const state = getDefaultState()

const mutations = {
  SET_USERPHONE: (state, data) => {
    state.userPhone = data
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_SYSTEM: (state, system) => {
    state.systemNode = system
  },
  SET_USERINFO: (state, userinfo) => {
    state.userinfo = userinfo
  },
  SET_NOREAD: (state, noRead = 0) => {
    state.noRead = noRead
  },
  SET_UPDATEVERSION: (state, updateVersion = false) => {
    state.updateVersion = updateVersion
  },
  SET_VERSIONCONTENT: (state, versionContent = '') => {
    state.versionContent = versionContent
  },
  SET_VERSION: (state, version = '') => {
    state.version = version
  },
  SET_MODEAUTH: (state, nodeAuth = []) => {
    state.nodeAuth = nodeAuth
  }
}
const getters = {
  noRead: state => state.noRead,
  updateVersion: state => state.updateVersion,
  versionContent: state => state.versionContent,
  nodeAuth: state => state.nodeAuth
}

const actions = {
  // 验证码登陆
  smslogin({ commit }, userInfo) {
    const { account, code, company_id, system_version, system_name, browser_version, browser_name, browser_core } = userInfo
    return new Promise((resolve, reject) => {
      smslogin({ account: account.trim(), code, company_id, system_version, system_name, browser_version, browser_name, browser_core }).then(response => {
        const { data } = response
        if (!Array.isArray(data)) {
          commit('SET_TOKEN', data.info.token)
          commit('SET_USERINFO', data.info.info)
          commit('SET_MODEAUTH', data.auth.auth_list)
          set(tokenKey, data.info.token)
          set(userinfoKey, JSON.stringify(data.info.info))
          set('nodeAuth', JSON.stringify(data.auth.auth_list))
        }
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 二维码验证码登陆
  wxlogin({ commit }, userInfo) {
    const { account, code, openid, nickname, headimgurl, unionid, sex, company_id, login_type } = userInfo
    return new Promise((resolve, reject) => {
      sweepCodeLogin({ account: account.trim(), code, openid, nickname, headimgurl, unionid, sex, company_id, login_type }).then(response => {
        const { data } = response
        if (!Array.isArray(data)) {
          commit('SET_TOKEN', data.info.token)
          commit('SET_USERINFO', data.info.info)
          commit('SET_MODEAUTH', data.auth.auth_list)
          set(tokenKey, data.info.token)
          set(userinfoKey, JSON.stringify(data.info.info))
          set('nodeAuth', JSON.stringify(data.auth.auth_list))
        }
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 账号密码登陆
  loginFn({ commit }, userInfo) {
    const { account, pass, company_id, system_version, system_name, browser_version, browser_name, browser_core } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: account.trim(), pass, company_id, system_version, system_name, browser_version, browser_name, browser_core }).then(response => {
        const { data } = response
        if(response.code === 201){
          setTimeout(() => {
            commit('SET_SYSTEM', true)
          },1000)
        }
        if (!Array.isArray(data)) {
          commit('SET_TOKEN', data.info.token)
          commit('SET_USERINFO', data.info.info)
          commit('SET_MODEAUTH', data.auth.auth_list)
          set(tokenKey, data.info.token)
          set(userinfoKey, JSON.stringify(data.info.info))
          set('nodeAuth', JSON.stringify(data.auth.auth_list))
        }
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 账号密码注册
  registerFn({ commit }, userInfo) {
    const { company_name, login_pass, code, account, confirm_pass, duty, source, invitation_code } = userInfo
    return new Promise((resolve, reject) => {
      registerAccount({ company_name, account: account.trim(), login_pass, code, confirm_pass, duty, source, invitation_code }).then(response => {
        const { data } = response
        if (!Array.isArray(data)) {
          commit('SET_TOKEN', data.info.token)
          commit('SET_USERINFO', data.info.info)
          commit('SET_MODEAUTH', data.auth.auth_list)
          set(tokenKey, data.info.token)
          set(userinfoKey, JSON.stringify(data.info.info))
          set('nodeAuth', JSON.stringify(data.auth.auth_list))
        }
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 退出登录
  logout({ _, state }) {
    return new Promise((resolve, reject) => {
      remove(tokenKey) // must remove  token  first
      remove(userinfoKey)
      remove('nodeAuth')
      resetRouter()
      resolve()
    })
  },
  // 重置token
  resetToken() {
    return new Promise(resolve => {
      remove(tokenKey) // must remove  token  first
      remove(userinfoKey)
      remove('nodeAuth')
      resolve()
    })
  },
  // 修改密码
  updatePassFn(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await updatePass(params)
      if (res.code === 200) {
        res && resolve(res)
      }
    })
  },
  // 获取用户手机号
  getPhoneFn({ commit }) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await getPhone()
      if (code === 200) {
        commit('SET_USERPHONE', data.phone)
        resolve()
      }
    })
  },
  // 忘记密码修改密码
  smsupdatePassFn(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await smsupdatePass(params)
      if (res.code === 200) {
        res && resolve(res)
      }
    })
  },
  // 忘记密码-校验验证码
  versmscodeFn(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await versmscode(params)
      if (res.code === 200) {
        res && resolve(res)
      }
    })
  },
  // 未读消息个数
  getNoReadNotice({ commit }, params = { page: 1, pageSize: 999999999, is_read: 1 }) {
    return new Promise(async(resolve, reject) => {
      const res = await noticeList(params)
      if (res.code === 200) {
        commit('SET_NOREAD', res.data.total)
        res && resolve(res)
      }
    })
  },
  // 切换主体
  switchCompany({ commit }, params = {}) {
    return new Promise(async(resolve, reject) => {
      switchCompany(params).then(response => {
        const { data } = response
        console.log(data)
        if (!Array.isArray(data)) {
          commit('SET_TOKEN', data.info.token)
          commit('SET_USERINFO', data.info.info)
          commit('SET_MODEAUTH', data.auth.auth_list)
          set(tokenKey, data.info.token)
          set(userinfoKey, JSON.stringify(data.info.info))
          set('nodeAuth', JSON.stringify(data.auth.auth_list))
        }
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  syncCompany({ commit }) {
    const syncState = getDefaultState()
    commit('SET_TOKEN', syncState.token)
    commit('SET_USERINFO', syncState.userinfo)
    commit('SET_MODEAUTH', syncState.nodeAuth)
    set(tokenKey, syncState.token)
    set(userinfoKey, JSON.stringify(syncState.userinfo))
    set('nodeAuth', syncState.nodeAuth)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

